module.exports = __webpack_public_path__ + "static/homebox-logo-small-white-2-transparent-1b76597f0678f5556f20da13bdc830ad.png";